__turbopack_context__.v({
  "buttonContainer": "Web3Button-module__-KoWTW__buttonContainer",
  "profileLink": "Web3Button-module__-KoWTW__profileLink",
  "walletIcon": "Web3Button-module__-KoWTW__walletIcon",
  "web3button": "Web3Button-module__-KoWTW__web3button",
});
